function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.063 9.516c0 .068.053.125.117.125h2.89c.064 0 .117-.057.117-.125v-.75c0-.07-.053-.125-.117-.125H7.18c-.064 0-.117.056-.117.125v.75zm-3.046.095l3-2.516c.06-.05.06-.142 0-.192l-3-2.514c-.018-.015-.04-.025-.064-.028-.023-.004-.047 0-.069.01-.021.01-.04.026-.052.046-.013.02-.02.044-.02.067v.98c0 .038.016.072.046.095L5.573 7 3.858 8.44c-.014.012-.025.027-.033.043-.008.017-.012.035-.013.053v.98c0 .106.124.164.205.095zM12.75.75H1.25c-.277 0-.5.223-.5.5v11.5c0 .277.223.5.5.5h11.5c.277 0 .5-.223.5-.5V1.25c0-.277-.223-.5-.5-.5zm-.625 11.375H1.875V1.875h10.25v10.25z"
});

function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "#3B4B57",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.ee1fa22b.svg";
export { ForwardRef as ReactComponent };